import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getAccountScopeUserSettings } from 'owa-session-store';

// Prime (boot) setting id under which the OCS `mail_showpreviewlinesinlistview` value is primed
// into the boot payload. Keep in sync with `primeSettingActionToNameMap` in
// owa-offline-prime-settings (action `setShowPreviewLinesInListView`).
const SHOW_PREVIEW_LINES_PRIME_SETTING_ID = 'Mail_ShowPreviewLinesInListView';

/**
 * Synchronously reads the message-preview-lines value from prime/boot settings, if the server
 * primed it into the boot payload. Returns `null` when the value is not primed or not a number,
 * in which case callers should fall back to the asynchronous OCS read. Reading synchronously on
 * boot avoids a flash where the message list renders a preview before the async OCS value resolves.
 */
export default function getShowPreviewLinesInListViewPrimeSetting(): number | null {
    const primeSettings = getAccountScopeUserSettings(
        getGlobalSettingsAccountMailboxInfo()
    )?.PrimeSettings;
    const value = primeSettings?.Items?.filter(
        item => item.Id === SHOW_PREVIEW_LINES_PRIME_SETTING_ID
    ).map(item => item.Value?.[0]?.value)[0];

    if (value == null) {
        return null;
    }

    try {
        const parsedValue = JSON.parse(value);
        return typeof parsedValue === 'number' ? parsedValue : null;
    } catch {
        return null;
    }
}
